/* HALE marketplace shared design tokens.
 *
 * Modern marketplace system — matches the redesigned Hale League landing
 * and the Hale brand console: white canvas, Chivo display type, charcoal
 * ink, Hale red accent. Deliberately NOT the old cream/serif editorial
 * look. The brand intake reads from the same tokens so the founder journey
 * is a seamless continuation of the Hale experience. */

// Typography (matches HaleLandingPage + console _theme)
export const HALE_DISPLAY     = "'Chivo', system-ui, -apple-system, sans-serif";
export const HALE_BODY        = "'IBM Plex Sans', system-ui, -apple-system, sans-serif";
export const HALE_MONO        = "'IBM Plex Mono', ui-monospace, monospace";

// Surface tokens (white canvas)
export const HALE_BG          = '#FFFFFF';                  // white canvas
export const HALE_NEUTRAL     = '#F7F7F8';                  // soft band
export const HALE_BG_SOFT     = '#FAFAFA';                  // raised card surface
export const HALE_BG_RAISED   = '#F4F4F5';                  // pinned card surface

// Hairlines
export const HALE_HAIR        = '#E4E4E7';
export const HALE_HAIR_STRONG = '#D4D4D8';

// Ink + text
export const HALE_INK         = '#111214';                  // primary text · charcoal
export const HALE_TEXT        = '#111214';
export const HALE_TEXT_MUTED  = '#71717A';                  // secondary text
export const HALE_TEXT_FAINT  = '#A1A1AA';                  // tertiary text · captions

// Accents (HALE red wordmark + CTAs)
export const HALE_RED         = '#E63946';
export const HALE_RED_DEEP    = '#C9192C';
export const HALE_CHAMPAGNE   = '#A07A14';                  // legacy gold (unused)

/* Category & retailer dictionaries shown in the intake. Kept centralised so
 * the founder-facing copy stays consistent across screens. */
export const CATEGORIES = [
  { key: 'grooming',         label: 'Grooming' },
  { key: 'supplements',      label: 'Supplements & Performance' },
  { key: 'fragrance',        label: 'Fragrance' },
  { key: 'sexual_wellness',  label: 'Sexual Wellness' },
  { key: 'skincare',         label: 'Skincare & Personal Care' },
  { key: 'lifestyle',        label: 'Lifestyle & Recovery' },
  { key: 'haircare',         label: 'Haircare' },
];

export const RETAILERS = [
  { key: 'sephora',     label: 'Sephora' },
  { key: 'credo',       label: 'Credo' },
  { key: 'wholefoods',  label: 'Whole Foods' },
  { key: 'target',      label: 'Target Clean' },
  { key: 'ulta',        label: 'Ulta Conscious Beauty' },
  { key: 'nordstrom',   label: 'Nordstrom' },
  { key: 'amazon_lux',  label: 'Amazon Luxury Stores' },
  { key: 'specialty',   label: 'Independent specialty' },
];

export const PACKAGING_MATERIALS = [
  'Glass', 'Aluminum', 'PCR-PET', 'Bio-resin', 'Refill pouches',
  'Stainless steel', 'Compostable paper',
];

export const SUSTAINABILITY_DECLS = [
  { key: 'carbon_offset',       label: 'Carbon-offset operations' },
  { key: 'b_corp',              label: 'B-Corp certified' },
  { key: 'leaping_bunny',       label: 'Leaping Bunny' },
  { key: 'supply_chain_audit',  label: 'Audited supply chain' },
  { key: 'living_wage',         label: 'Living-wage commitments' },
  { key: 'cradle_to_cradle',    label: 'Cradle-to-cradle program' },
];

export const STANDARDS_NARRATIVE = {
  hale_reviewed: {
    name: 'HALE Reviewed™',
    short: 'Scientific governance · retailer readiness',
    blurb: 'Ingredient transparency, formula review, packaging governance overlays, '
         + 'and retailer-readiness documentation — assembled into a portable, '
         + 'reusable scientific governance layer for modern men\'s brands.',
  },
  hale_verified: {
    name: 'HALE Verified™',
    short: 'Documentation maturity · supplier interoperability',
    blurb: 'Supplier-supported documentation, packaging governance overlays, '
         + 'and sustainability interoperability — built around the documentation '
         + 'expectations modern retailers are converging on.',
  },
  both: {
    name: 'HALE Reviewed™ + HALE Verified™',
    short: 'Full governance infrastructure',
    blurb: 'The full scientific governance infrastructure stack — '
         + 'ingredient review, packaging governance, supplier documentation, '
         + 'and retailer-readiness portability. Built for portfolio operators.',
  },
};
